module.exports = __webpack_public_path__ + "img/index07.7faf0512.jpg";